import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
//import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_REQUIRED, MSG_INVITE_AS_FRIEND_SUCCESS, MSG_INVITE_AS_FRIEND_FAILED, MSG_INVITE_AS_FRIEND_ALREADY_REGISTER } from '../../../configs/msgConfigs'; // 
import { LBL_APP_NAME, LBL_SETTINGS, LBL_INVITE_A_FRIEND, LBL_RECIPIENT_NAME, LBL_RECIPIENT_EMAIL, LBL_INVITE_AS, LBL_CREW_MEMBER, LBL_AFFILIATE, LBL_SEND_INVITE, LBL_BACK_TO_STAFF_LIST } from '../../../configs/labelConfigs';
import { ROUTE_AFFILIATE_REFRESH, LOGIN_AFFILIATE_GROUP, LOGIN_CREW_GROUP, ROUTE_AFFILIATE_CREW} from '../../../configs/staticConfigs';
import { INVITE_AS_FRIEND_SUCCESS } from '../../../actions/';

import Toast from '../../commons/helpers/toast';

// import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import {validateEmail} from '../../../utils/validation';  

import { inviteAsFriendAction } from '../../../actions/commonActions';
import { Link } from 'react-router-dom';

class InviteFriend extends Component { 

    constructor(props){
        super(props)

        this.state = {
            recipientName : '', 
            recipientEmail : '', 
            formErrors_recipientName : "", 
            formErrors_recipientEmail : "", 
            selectedOption: LOGIN_CREW_GROUP, 
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            formErrors_common: '' 
        }

        this.onHandleChange = this.onHandleChange.bind(this);
    }

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        document.title = LBL_APP_NAME+' - '+LBL_SETTINGS+' - '+LBL_INVITE_A_FRIEND;        
    }   
    
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 
    
    onHandleChange = (event) =>{
        const {name, value} = event.target; 
        let errMsg = ''; 
        let valStr = value; //.trim(); 
        if(name==='recipientName') {
            errMsg = valStr.trim()==='' ? MSG_REQUIRED : '';; 
            this.setState({ recipientName:value, formErrors_recipientName: errMsg });  
        }  
        if(name==='recipientEmail') {  
            errMsg = valStr.trim()==='' || validateEmail(value) === false ? MSG_REQUIRED : ''; 
            this.setState({ recipientEmail:value, formErrors_recipientEmail: errMsg });  
        }   
        else if(name==='inviteAs') { 
            this.setState({selectedOption:valStr});  
        }  
    }  

    checkFormData() {
        if(this.state.recipientName.trim()==='') {  
            this.setState({formErrors_recipientName:MSG_REQUIRED});  
            return false; 
        } 
        else if(this.state.recipientEmail.trim()==='') {   
            this.setState({formErrors_recipientEmail:MSG_REQUIRED});  
            return false; 
        }
        else if(validateEmail(this.state.recipientEmail) === false) {   
            this.setState({formErrors_recipientEmail:MSG_REQUIRED});  
            return false; 
        }
        else {
            return true; 
        }
    }

    sendInvitation = () =>{
        if(this.checkFormData()) {
            this.props.inviteAsFriendAction({name:this.state.recipientName, email:this.state.recipientEmail, invite_as:this.state.selectedOption}); 
        }
    }

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) {         
        const { inviteAsFriendStatus,inviteAsFriendActivity, inviteAsFriendResponse} = this.props;
        if (inviteAsFriendActivity && (inviteAsFriendStatus !== prevProps.inviteAsFriendStatus || inviteAsFriendActivity!==prevProps.inviteAsFriendActivity)) {

            var arrResp = inviteAsFriendActivity ? inviteAsFriendActivity.split('~~') : []; 
            var actString = arrResp[0]; 
            
            if(actString===INVITE_AS_FRIEND_SUCCESS && inviteAsFriendStatus===200){ 
                if (inviteAsFriendResponse["status"] == 'success'){
                    this.setState({toastSuccess:true,toastFlag:true,toastMessage:MSG_INVITE_AS_FRIEND_SUCCESS});
                } else if (inviteAsFriendResponse["message"] == 'user_already_registered'){
                    this.setState({toastSuccess:false,toastFlag:true,toastMessage:MSG_INVITE_AS_FRIEND_ALREADY_REGISTER});
                }else{
                    this.setState({toastSuccess:false,toastFlag:true,toastMessage:MSG_INVITE_AS_FRIEND_FAILED});
                }
                setTimeout(()=> {
                    this.onCloseToast();
                }, 4000);
            }
            else { 
                this.setState({toastSuccess:false,toastFlag:true,toastMessage:MSG_INVITE_AS_FRIEND_FAILED});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 4000);
            }  

        }
    }
       
    render(){
        const { toastMessage,toastFlag,toastSuccess } = this.state

        const { inviteAsFriendStatus } = this.props;  

        if(inviteAsFriendStatus===401){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="box">
                    <div className="box-head">
                    <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_CREW}>{LBL_BACK_TO_STAFF_LIST}</Link> </div>

                        <div className="to-right">&nbsp; 
                        </div>
                    </div>

                   


                    <div className="box-content">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_RECIPIENT_NAME}</label>
                                    <div className="text-input">
                                        <input type="text" placeholder={LBL_RECIPIENT_NAME} name="recipientName" value={this.state.recipientName} onChange={this.onHandleChange} maxLength = {120} className={this.state.formErrors_recipientName.length >0 ? "input-error" : ''} />
                                    </div>
                                </div>
                            </div>  
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_RECIPIENT_EMAIL}</label>
                                    <div className="input email-input">
                                        <input type="email" placeholder={LBL_RECIPIENT_EMAIL} name="recipientEmail" value={this.state.recipientEmail} onChange={this.onHandleChange} maxLength = {120} className={this.state.formErrors_recipientEmail.length >0 ? "input-error" : ''} />
                                        {this.state.formErrors_recipientEmail.length >0 && this.state.formErrors_recipientEmail!==MSG_REQUIRED && 
                                       <div className="text-red left-align text-12">{this.state.formErrors_recipientEmail}</div>}
                                    </div>
                                </div>
                            </div> 
                        </div> 

                        <div className="row padding-top-10">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_INVITE_AS}</label>
                                    <div className="checkbox-wrapper"> 
                                        {/*<div className="custom-radio padding-right-15">
                                            <input type="radio" id="affiliate" name="inviteAs" value={LOGIN_AFFILIATE_GROUP} checked={this.state.selectedOption === LOGIN_AFFILIATE_GROUP} onChange={e => this.onHandleChange(e)}/>
                                            <label className="radio" htmlFor="affiliate"></label>
                                            <label className="labeltext" htmlFor="affiliate">{LBL_AFFILIATE}</label>
                                        </div>*/}
                                        <div className="custom-radio">
                                            <input type="radio" id="crewmember" name="inviteAs"  value={LOGIN_CREW_GROUP} checked={this.state.selectedOption === LOGIN_CREW_GROUP} onChange={e => this.onHandleChange(e)} />
                                            <label className="radio" htmlFor="crewmember"></label>
                                            <label className="labeltext " htmlFor="crewmember">{LBL_CREW_MEMBER}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="divFloatRight padding-top-10">
                            <button className="btn btn-primary launch-modal" onClick={this.sendInvitation}>{LBL_SEND_INVITE}</button>
                        </div>
                        
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = (state) => {  
    return {
        inviteAsFriendStatus:state.commons.inviteAsFriendStatus,
        inviteAsFriendActivity:state.commons.inviteAsFriendActivity,
        inviteAsFriendResponse:state.commons.inviteAsFriendResponse,
        errorData: state.commons.errorData,
    } 
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        inviteAsFriendAction:data=>inviteAsFriendAction(data),  
    },dispatch); 
} 
export default connect(mapStateToProps,mapDispatchToProps)(InviteFriend);


